import S from 's-js';
import { IAjax, Request } from 'lib/Ajax';
import { ValidationWatcher } from 'lib/validationWatcher';
import { Entrypoints } from 'core/app/entrypoints';

import { ResetPasswordRequest } from 'data/models/Accounts';

import { Login, LoginParams } from 'portcall/login/model';

export interface ResetPasswordParams {
    userId : number;
    token : string;
}

export function ResetPassword(
    ajax : IAjax,
    entrypoints : Entrypoints,
    loginModel : (params : LoginParams) => Login,
    { userId, token } : ResetPasswordParams
) {
    const client = ajax.Url<ResetPasswordRequest>(entrypoints.ResetPassword),
        validation = ValidationWatcher(client),
        resetPassword = new ResetPasswordRequest({
            UserId: userId,
            Token: token
        }),
        resetPasswordRequest = S.data<Request<{}> | null>(null),
        showLogin = S.data(false),
        login = S(() => showLogin() ? loginModel({ useLandingPage: true, onHidePopup: () => showLogin(false) }) : null),
        showPasswordValidation = S.data(false);

    return {
        ResetPassword: resetPassword,
        ResetPasswordRequest: resetPasswordRequest,
        Validation: validation,
        Submit,
        ShowLogin: showLogin,
        Login: login,
        ShowPasswordValidation: showPasswordValidation
    };

    function Submit() {
        resetPasswordRequest(client.Post(resetPassword));
    }
}
export type ResetPassword = ReturnType<typeof ResetPassword>;


// WEBPACK FOOTER //
// ./apps/portcall/resetpassword/model.ts